module.exports = __webpack_public_path__ + "img/ade.86883acd.jpg";